import React, { useEffect } from 'react';
import RootStore from './store/RootStore';
import { createBrowserHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { InquiryListPage } from './components/pages/InquiryListPage';
import { InquiryDetailPage } from './components/pages/InquiryDetailPage';
import { NotFoundPage } from './components/pages/NotFoundPage';
import { LoginPage } from './components/pages/LoginPage';
import { OmniLoginPage } from './components/pages/OmniLoginPage';
import { GenericExceptionPage } from './components/pages/GenericExceptionPage';
import { reaction } from 'mobx';
import { InconsistencyExceptionPage } from './components/pages/InconsistencyExceptionPage';

const browserHistory = createBrowserHistory();
const routerStore = new RouterStore();
const history = syncHistoryWithStore(browserHistory, routerStore);
export const rootStore = new RootStore(routerStore);

export const useRootStore = () =>
  React.useContext(React.createContext(rootStore));
export const useRouterStore = () =>
  React.useContext(React.createContext(routerStore));

const App = () => {
  useEffect(() => {
    window.addEventListener('popstate', () => {
      console.warn('browser-back / forward is not supported.');
      rootStore.inquiryPageStore.showErrorPage = true;
    });
    // here handles event on page transition
    const disposer = reaction(
      () => routerStore.location.pathname,
      (pathname) => {
        // always emit 'blur' when page transition
        rootStore.socketStore.emitWatchingState('blur');
      },
    );

    return () => {
      disposer(); // cleanup reaction
    };
  });

  return (
    <DndProvider backend={HTML5Backend}>
      <Router history={history}>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/inquiry" />} />
          {rootStore.appStore.isLoginPageShowAllowed() && (
            <Route exact path="/login/dev" component={LoginPage} />
          )}
          <Route exact path="/login" component={InquiryDetailPage} />
          <Route exact path="/inquiry/new" component={InquiryDetailPage} />
          <Route exact path="/inquiry" component={InquiryListPage} />
          <Route exact path="/auth" component={OmniLoginPage} />
          <Route
            exact
            path="/inquiry/:activeInquiryId"
            component={InquiryDetailPage}
          />
          <Route exact path="/404" component={NotFoundPage} />
          <Route exact path="/50x" component={GenericExceptionPage} />
          <Route
            exact
            path="/inconsistent"
            component={InconsistencyExceptionPage}
          />
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    </DndProvider>
  );
};

export default App;
